module.exports = __webpack_public_path__ + "static/media/haiwaiyewshangzhuangliucheng.2e78fbfd.png";